import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServicesCTA() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-foreground-900 px-6 py-14 md:px-12 md:py-20">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-primary-500/20 blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-accent-500/10 blur-3xl"></div>

          <div className="relative max-w-2xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight mb-5">
              {t('servicesPage.cta.title')}
            </h2>
            <p className="text-background-50/75 text-sm md:text-base leading-relaxed mb-9">
              {t('servicesPage.cta.text')}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold transition-all hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                {t('servicesPage.cta.button')}
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="mailto:info@limpiasarl.ch"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-background-50/25 text-background-50 text-sm font-semibold transition-all hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
              >
                {t('servicesPage.cta.secondary')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}